module.exports = __webpack_public_path__ + "img/2.f30fc289.png";